// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';

export default class ContentIcon extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            icon: {
                width: CoreMetrics.IconSize.Medium(),
                height: CoreMetrics.IconSize.Medium(),
                borderRadius: "50%",
                border: "2px solid " + CoreMetrics.Color.Control.Default,
                display: "inline-block",
                boxSizing: "border-box",
                flexShrink: 0,
            },
        });
        return (
            <div className={css(styles.icon)}>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/icons/ContentIcon.jsx